import * as Yup from "yup";
import { CURRENCY } from "../../../../components/Constants";

export const qualitySpecificationsInitialValues = {
  quality_specification_id: "",
  value: "",
};

export const documentsInitialValues = {
  document_id: "",
  value: "",
};

export interface ProductData {
  quality_specification: {
    product_id: string;
    name: string;
    quality_specification_id: string;
    value: string;
  };
}

export interface SalesContractProducts {
  product_id: string;
  is_product_variety: boolean;
  product_variety: string;
  quantity: number;
  // quantity_unit_id: string;
  price: number;
  no_of_containers: string;
  container_load: string;
  no_of_bags: string;
  packing_type_id: string;
  packing_net_weight: string;
  total_net_weight: string;
  packing_gross_weight: string;
  total_gross_weight: string;
  // packing_unit_id: string;
  total_amount: string;
}

export const initialSalesContractProducts: SalesContractProducts = {
  product_id: "",
  is_product_variety: false,
  product_variety: "",
  quantity: 0,
  // quantity_unit_id: "",
  price: 0,
  no_of_containers: "",
  container_load: "",
  no_of_bags: "",
  packing_type_id: "",
  packing_net_weight: "",
  total_net_weight: "",
  packing_gross_weight: "",
  total_gross_weight: "",
  // packing_unit_id: "",
  total_amount: "",
};

export const salesContractInitialValues = {
  contract_no: "",
  reference_no: "",
  contract_date: null,
  sales_contract_products: [],
  buyer_id: "",
  broker_id: "",
  status: "",
  currency: CURRENCY.USD.NAME,
  sub_total: 0,
  total_no_of_bags: 0,
  total_net_weight: 0,
  total_gross_weight: 0,
  marking: "",
  marking_files: [],
  final_destination: "",
  port_of_loading_id: "",
  port_of_discharge: "",
  shipment: "",
  trans_shipment: "",
  partial_shipment: "",
  payment_terms: "",
  weight_and_quality: "",
  arbitration: "",
  is_digital_signature: null,
  quality_specification: [],
  document: [],
  exporter_bank_id: "",
  buyer_bank_id: "",
  general_terms: [],
  // sales_contract_supplier_products: [],
};

export const qualitySpecificationsValidationSchema = Yup.object().shape({
  quality_specification_id: Yup.string().required(
    "Quality specification is required",
  ),
  value: Yup.string().required("Value is required"),
});

export const documentsValidationSchema = Yup.object().shape({
  document_id: Yup.string().required("Document is required"),
  value: Yup.string().required("Value is required"),
});

export const generalTermsValidationSchema = Yup.string().required(
  "General term ID is required",
);

// export const SalesProductValidationSchema = Yup.array()
//   .of(
//     Yup.object().shape({
//       product_id: Yup.string().required("Product is required"),
//       price: Yup.number()
//         .required("Price is required")
//         .test("price-required", "Price is required", function (value: any) {
//           return !(value <= 0);
//         }),
//       quantity: Yup.number()
//         .required("Quantity is required")
//         .test(
//           "quantity-required",
//           "Quantity is required",
//           function (value: any) {
//             return !(value <= 0);
//           }
//         ),
//       // quantity_unit_id: Yup.string().nullable(),
//       no_of_containers: Yup.number()
//         .moreThan(0, "no_of_containers must be greater than 0")
//         .nullable(),
//       container_load: Yup.string().nullable(),
//       packing_type_id: Yup.string().nullable(),
//       // packing_unit_id: Yup.string().nullable(),
//       no_of_bags: Yup.number()
//         .moreThan(0, "no_of_bags must be greater than 0")
//         .nullable(),
//       packing_net_weight: Yup.number()
//         .moreThan(0, "packing_net_weight must be greater than 0")
//         .nullable(),
//       total_net_weight: Yup.number()
//         .moreThan(0, "total_net_weight must be greater than 0")
//         .nullable(),
//       packing_gross_weight: Yup.number()
//         .moreThan(0, "packing_gross_weight must be greater than 0")
//         .nullable(),
//       total_gross_weight: Yup.number()
//         .moreThan(0, "total_gross_weight must be greater than 0")
//         .nullable(),
//       total_amount: Yup.number()
//         .required("total_amount is required")
//         .moreThan(0, "total amount must be greater than 0"),
//     })
//   )
//   .min(1, "At least 1 product is required");

export const SalesProductValidationSchema = Yup.array()
  .of(
    Yup.object().shape({
      product_id: Yup.string().required("Product is required"),

      quantity: Yup.number()
        .typeError("Quantity must be a number")
        .required("Quantity is required")
        .moreThan(0, "Quantity must be greater than 0"),

      // Price should only be validated if user actually entered it
      price: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .nullable(),

      no_of_containers: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .nullable(),

      container_load: Yup.string().nullable(),

      packing_type_id: Yup.string().nullable(),

      no_of_bags: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .nullable(),

      packing_net_weight: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .nullable(),

      total_net_weight: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .nullable(),

      packing_gross_weight: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .nullable(),

      total_gross_weight: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .nullable(),

      total_amount: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .nullable(),
    }),
  )
  .min(1, "At least 1 product is required");

// export const salesContractSupplierProductValidationSchema = Yup.object().shape({
//   product_id: Yup.string().required("product is required"),
//   purchase_id: Yup.string().required("purchase order is required"),
//   quantity: Yup.number()
//     .required("quantity is required")
//     .moreThan(0, "Quantity must be greater than 0"),
//   // unit_id: Yup.string().nullable(),
// });

export const salesContractValidationSchema = Yup.object().shape({
  contract_no: Yup.string().required("Contract no is required"),
  reference_no: Yup.string(),
  contract_date: Yup.date().required("Contract date is required"),
  buyer_id: Yup.string().required("Buyer is required"),
  broker_id: Yup.string(),
  status: Yup.string().required("Status is required"),
  currency: Yup.string().required("Currency is required"),
  sales_contract_products: SalesProductValidationSchema,
  sub_total: Yup.number()
    .moreThan(0, "sub_total must be greater than 0")
    .required("sub Total is required"),
  total_net_weight: Yup.number()
    .moreThan(0, "total_net_weight must be greater than 0")
    .nullable(),
  total_gross_weight: Yup.number()
    .moreThan(0, "total_gross_weight must be greater than 0")
    .nullable(),
  total_no_of_bags: Yup.number()
    .moreThan(0, "total_no_of_bags must be greater than 0")
    .nullable(),
  marking: Yup.string(),
  marking_files: Yup.array().optional(),
  final_destination: Yup.string(),
  port_of_loading_id: Yup.string(),
  port_of_discharge: Yup.string(),
  shipment: Yup.string(),
  trans_shipment: Yup.string(),
  partial_shipment: Yup.string(),
  payment_terms: Yup.string(),
  weight_and_quality: Yup.string(),
  arbitration: Yup.string(),
  is_digital_signature: Yup.string().nullable(),
  quality_specification: Yup.array().of(qualitySpecificationsValidationSchema),
  document: Yup.array().of(documentsValidationSchema),
  exporter_bank_id: Yup.string(),
  buyer_bank_id: Yup.string(),
  general_terms: Yup.array().of(generalTermsValidationSchema),
  // sales_contract_supplier_products: Yup.array().of(
  //   salesContractSupplierProductValidationSchema
  // ),
});
